export default __webpack_public_path__ + "static/media/toilet.8382597d.svg";